import type { gsap as Gsap } from "gsap";

export function setupCaseCardHoverAnimation(
  gsap: typeof Gsap,
  card: HTMLElement,
) {
  const arrow = card.querySelector<HTMLElement>(".case-card-arrow");
  const body = card.querySelector<HTMLElement>(".case-card-body");
  const media = card.querySelector<HTMLElement>(".case-card-media");

  gsap.set(arrow, {
    opacity: 0,
    x: -8,
    y: 8,
  });

  const enter = () => {
    const timeline = gsap.timeline({
      defaults: {
        ease: "power3.out",
        duration: 0.45,
      },
    });

    timeline
      .to(
        arrow,
        {
          opacity: 1,
          x: 0,
          y: 0,
          duration: 0.35,
          ease: "power3.out",
        },
        0,
      )
      .to(
        body,
        {
          y: -18,
          duration: 0.5,
          ease: "power3.out",
        },
        0,
      )
      .to(
        media,
        {
          y: -44,
          duration: 0.55,
          ease: "power3.out",
        },
        0,
      );
  };

  const leave = () => {
    const timeline = gsap.timeline({
      defaults: {
        ease: "power3.out",
        duration: 0.38,
      },
    });

    timeline
      .to(
        card,
        {
          y: 0,
          boxShadow: "0 0px 0px rgba(0,0,0,0)",
        },
        0,
      )
      .to(
        arrow,
        {
          opacity: 0,
          x: -8,
          y: 8,
          duration: 0.22,
          ease: "power3.out",
        },
        0,
      )
      .to(
        body,
        {
          y: 0,
          duration: 0.45,
          ease: "power3.out",
        },
        0,
      )
      .to(
        media,
        {
          y: 0,
          duration: 0.45,
          ease: "power3.out",
        },
        0,
      );
  };

  card.addEventListener("mouseenter", enter);
  card.addEventListener("mouseleave", leave);
  card.addEventListener("focusin", enter);
  card.addEventListener("focusout", leave);

  return () => {
    card.removeEventListener("mouseenter", enter);
    card.removeEventListener("mouseleave", leave);
    card.removeEventListener("focusin", enter);
    card.removeEventListener("focusout", leave);
  };
}
